import axios from "axios";
import Config from "../../../config";

const v2_actionEditarNotaLead = (noteId, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/crm/leads/notes/${noteId}/edit`,
        data
    });
};

export default v2_actionEditarNotaLead;
